module.exports = __webpack_public_path__ + "img/toastmastere.2d917197.jpg";